export const REFRESH_WITHOUT_SERVICE_CHANGE = Object.freeze({
    servicesChanged: false,
    requestIdMayChange: false
});
